module.exports = fox => {
    'use strict';
    
    fox.registerWidget('Verification_Error', {
        
        configure() {

            this.registerOptions('', {
                autoRender: true
            });

            this.callParent('configure', arguments);
        },

        prepareEmbeddedWidgets() {
			this._bindData = {
                cooldown: 0
			};

			this.bindTemplateVariables(this._bindData, ['cooldown']);

			this.callParent('prepareEmbeddedWidgets', arguments);
		},

        countdown(cooldown) {
            var fmtMSS = s => {return(s-(s%=60))/60+(9<s?':':':0')+s};

            this._bindData.cooldown = fmtMSS(cooldown);

            this.stop();

            return new fox.Promise((resolve, reject) => {
                this.timer = window.setInterval(() => {
                    --cooldown;
    
                    if (cooldown) {
                        this._bindData.cooldown = fmtMSS(cooldown);
                    } else {
                        this.stop();
                        this.dispatchEvent('cooldown_end');
                        resolve(true);
                    }
                }, 1000);
            });
        },

        stop() {
            if (this.timer) {
                window.clearInterval(this.timer);
            }
        }

    });
}


// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/verification-form/verification-error.es.js